import { render, staticRenderFns } from "./ViewTestPaper.vue?vue&type=template&id=5ca0a607&scoped=true&"
import script from "./ViewTestPaper.vue?vue&type=script&lang=js&"
export * from "./ViewTestPaper.vue?vue&type=script&lang=js&"
import style0 from "./ViewTestPaper.vue?vue&type=style&index=0&lang=less&"
import style1 from "./ViewTestPaper.vue?vue&type=style&index=1&id=5ca0a607&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca0a607",
  null
  
)

export default component.exports